export default __webpack_public_path__ + "static/media/STRIP.3a6626ec.png";